// PWA glue: service-worker registration.
// Kept entirely self-contained so it cannot affect the existing desktop UI —
// the service worker is only registered in production builds.

const isDev = Boolean(globalThis.__DEV__);

export function initPwa(): void {
  registerServiceWorker();
}

function registerServiceWorker(): void {
  if (!("serviceWorker" in navigator)) return;
  // Skip in dev: an aggressive cache would fight esbuild's live rebuilds.
  if (isDev) return;

  window.addEventListener("load", () => {
    // Deliberately no auto-reload on update: force-reloading the page when a
    // new worker activates would wipe out whatever the user is doing (e.g.
    // typing in chat). A new version simply takes effect on the next page
    // load, which is the non-disruptive, desktop-safe behaviour.
    navigator.serviceWorker.register("/sw.js").catch((err: unknown) => {
      console.warn("[pwa] service worker registration failed:", err instanceof Error ? err.message : err);
    });
  });
}
